<div>
  <div class="section">
    <h1>Lieferant</h1>

    <div *ngIf="adresse.Name1" class="ion-activatable" appClick (clicked)="onLieferantWaehlenClicked()">
      <div class="adresse">
        <div class="adresse-row">
          <div class="adresse-name">{{ adresse.Name1 }}</div>
          <div class="adresse-name2" *ngIf="adresse.Name2">{{ adresse.Name2 }}</div>
          <div class="adresse-name3" *ngIf="adresse.Name3">{{ adresse.Name3 }}</div>
          <div class="adresse-nummer">NR: {{ adresse.AdressNummer }}</div>
        </div>
      </div>
    </div>

    <ion-button *ngIf="!adresse.Name1" appClick (clicked)="onLieferantWaehlenClicked()" expand="full" color="light">
      Lieferant auswählen
    </ion-button>
  </div>
</div>